import type { Scope } from '@/sections';
import experiment from 'experiment';

export const enforceSupportMobile = (scope: Scope) => {
  const masterPageRef = scope.editorAPI.components.get.byId(
    scope.editorAPI.pages.getMasterPageId(),
  );
  const supportMobile =
    scope.editorAPI.components.data.get(masterPageRef).supportMobile;

  if (
    experiment.isOpen('se_fixUnableToSwitchToMobileEditor') &&
    supportMobile === false
  ) {
    scope.editorAPI.components.data.update(masterPageRef, {
      supportMobile: true,
    });
  }
};
